import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation AddCartItemMutation($input: ModifyPortfolioItemsInput!) {
        modifyPortfolioItems(input: $input) {
            portfolio {
                items {
                    totalResults
                }
            }
        }
    }
`;

function addCartItem({ environment, itemsIds, userId, onCompleted, onError }) {
    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                action: 'ADD',
                portfolioType: 'CART',
                itemsIds,
                userId,
            },
        },
        onCompleted,
        onError,
    });
}

export default { commit: addCartItem };
